if (!customElements.get("custom-select")) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
    }

    toggle() {
      this.trigger.classList.toggle("open");
      this.dropdown.classList.toggle("open");
    }

    close() {
      this.trigger.classList.remove("open");
      this.dropdown.classList.remove("open");
    }

    connectedCallback() {
      this.trigger = this.querySelector(".select-trigger");
      this.dropdown = this.querySelector(".select-options");
      this.selectedText = this.querySelector(".selected-text");
      this.options = this.querySelectorAll(".select-option");

      this.trigger.addEventListener("click", () => {
        this.toggle();
      });

      this.options.forEach((option) => {
        option.addEventListener("click", () => {
          this.selectedText.textContent = option.textContent;

          this.options.forEach((opt) => opt.classList.remove("is-active"));
          option.classList.add("is-active");

          this.close();

          const input = document.querySelector(
            `[value="${CSS.escape(option.getAttribute("data-value"))}"]`
          );

          input.click();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }

  customElements.define("custom-select", CustomSelect);

  document.addEventListener("click", (e) => {
    if (e.target.closest("custom-select")) return;

    document.querySelectorAll("custom-select").forEach((select) => {
      select.close();
    });
  });
}
